export default "__VITE_ASSET__Bi96kyak__"